export const mapArrayByKey = <T, K extends keyof T>(list: T[], key: K) => {
  return list.reduce<Record<string, T>>((acc, item) => {
    const keyValue = item[key];
    if (typeof keyValue === "string" && keyValue.length > 0) {
      acc[keyValue] = item;
    }
    return acc;
  }, {});
};
